import { useState, useEffect } from 'react';

const DEFAULT_BREAKPOINT = 768; // same as $breakpoint-tablet

interface WindowDimensions {
	width: number;
	height: number;
	isResponsive: boolean;
}

export function useWindowDimensions(
	breakpoint: number = DEFAULT_BREAKPOINT,
): WindowDimensions {
	const [dimensions, setDimensions] = useState<WindowDimensions>({
		width: window.innerWidth,
		height: window.innerHeight,
		isResponsive: window.innerWidth < breakpoint,
	});

	useEffect(() => {
		function handleResize() {
			const width = window.innerWidth;
			const height = window.innerHeight;
			setDimensions({
				width,
				height,
				isResponsive: width < breakpoint,
			});
		}

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, [breakpoint]);

	return dimensions;
}
